var play_icon_rtlignore_default = {
  "shadow": "n8G2a",
  "playIcon": "_7qhhs"
};
export {
  play_icon_rtlignore_default as default
};
//# sourceMappingURL=play-icon.rtlignore-scss.js.map
